export default __webpack_public_path__ + "static/media/SWIM_desktop.8bc8a6da.png";